import Nullstack from 'nullstack';
export default function IconLadderOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ladder-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 3v1m0 4v13"
  }), "   ", Nullstack.element("path", {
    d: "M16 3v9m0 4v5"
  }), "   ", Nullstack.element("path", {
    d: "M8 14h6"
  }), "   ", Nullstack.element("path", {
    d: "M8 10h2m4 0h2"
  }), "   ", Nullstack.element("path", {
    d: "M10 6h6"
  }), "   ", Nullstack.element("path", {
    d: "M8 18h8"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}